package org.gymly.auth

import kotlinx.browser.window
import org.w3c.dom.events.Event

actual fun installIdleActivityListener(onActivity: () -> Unit): () -> Unit {
    val events = arrayOf("mousemove", "mousedown", "keydown", "scroll", "touchstart", "click")
    val handler: (Event) -> Unit = { onActivity() }
    events.forEach { window.addEventListener(it, handler) }
    return {
        events.forEach { window.removeEventListener(it, handler) }
    }
}
